import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import AuthNavbar from '../navigation/authnavigation.jsx';
import Loader from '../loader/loader.jsx';
import s from '../../services/allservices.jsx';
import CardInfo from '../dashboard/cardlist'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import { getClientId, getClientSecret,buildClientHeader } from "../../utils/clientAuth.js";
const styles = {
    customWidth: {
        width: 150,
    },
    customWidth1: {
        width: "100%",
        fontSize: "14px",
        cursor: "pointer"

    },
    customWidth2: {
        width: "100%",
        fontSize: "12px",
        fontWeight: "600"

    },
    customWidth3: {
        width: "100%",
        fontSize: "10px !important",
        fontWeight: "600"

    },

    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid #333",
        position: "relative",
        width: "98%"

    },
    buttonStyle: {
        background: "rgba(41, 40, 40, 0.87)",
    },
    floatingLabelStyle: {
        color: "#333",
        fontSize: "14px",
        fontWeight: 600

    },
    floatingLabelFocusStyle: {
        color: "#333"
    },
}

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState
})
const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    }
})

const JSEncrypt = window.JSEncrypt

class TokenList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenListData: [],
            loader :false,

            cardDetailsId: "",
            selectedCard: [],
            selectedNewCard: [],
            cardStatus: '',
            cardAccount: 1,
            filteredCards: [],
            Toggled: false,
            checked: false,
            updateAction : "",
            disabled : true,
        }
    }


    componentDidMount() {
    const { publicKey } = this.props
    const { cardState } = this.props
        let _this = this

        if (cardState && cardState.length !== 0) {

            var filteredR = cardState.body.filter((val) => {

                return (val.cardType)
            })

            let filteredCards = filteredR

            this.setState({
                loader: false,
                cardAccount: filteredCards[0].cardDetailsId,
                selectedCard: filteredCards[0],
                selectedNewCard: [filteredCards[0]],
                filteredCards: filteredCards,
                cardInUse: filteredCards[0],
            }, () => {

                _this.setState({
                    loader: true
                })
                if (this.state.selectedCard && (this.state.selectedCard.cardStatus === "Unlocked" )) {
                    this.setState({
                        Toggled: false,
                        // cardStatus: 'L'
                    })
                } else {
                    this.setState({
                        Toggled: true,
                        // cardStatus: 'UL'
                    })
                }
            })

        }
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);


    console.log("Now State" , this.state)
    console.log("Now Props", this.props)
    this.dogetToken()

     }


  componentWillReceiveProps(nextProps) {

        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                var filteredR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType)
                })
                var filteredCards = filteredR

                this.setState({
                    loader: false,
                    cardAccount: filteredCards[0].cardDetailsId,
                    selectedCard: filteredCards[0],
                    selectedNewCard: [filteredCards[0]],
                    filteredCards: filteredCards,
                    cardInUse: filteredCards[0],
                }, () => {
                    this.dogetToken()

                    // if (this.state.selectedCard && (this.state.selectedCard.cardStatus === "Unlocked" )) {
                    //     this.setState({
                    //         Toggled: false,
                    //         cardStatus: 'L'
                    //     })
                    // } else {
                    //     this.setState({
                    //         Toggled: true,
                    //         cardStatus: 'UL'
                    //     })
                    // }
                })
            }
        } catch (e) {

        }


    }

    handleSelect = (event, index, value) => {

        const { filteredCards } = this.state
        
        for (let i = 0; i < filteredCards.length; i++) {
            if (filteredCards[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: filteredCards[i],
                    selectedCard: filteredCards[i],
                    selectedNewCard: [filteredCards[i]],
                })
            }
        }

        this.setState({ cardAccount: value }, () => {
            
            for (let i = 0; i < filteredCards.length; i++) {
                if (value === filteredCards[i].cardDetailsId) {
                    this.setState({
                        selectedCard: filteredCards[i]
                    }, () => {
                        this.dogetToken()
                    })
                }
            }
        });

    }

    dogetToken = () =>{
        if( this.state.selectedCard && this.state.selectedCard.kitNo){


        this.setState({
            loader : true
        })
          let state = {
                    kitNo: this.state.selectedCard.kitNo,
                    entityId: this.state.selectedCard.customerId
            }
            let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
            let traceId = getClientId();
            fetch(plink + s.getTokenList, {
                method: "POST",
                headers: new Headers({
                  Authorization: `Token ${localStorage.getItem("token")}`,
                //   Authorization : 'Token eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDaGFybGllUkwiLCJhY2NvdW50SWQiOiIyMTJGQ0hBUkxJRSIsInJvbGUiOiJhZG1pbiIsImlzcyI6IiNAIUhlYWx0aDVDa21mIUAjIiwiZXhwIjoxNzUxNDM1MjE1LCJpYXQiOjE3NTEzNDg4MTV9.U1EGMNrmrQ2hVevxpM-7hzMAonQ3N_cGqecD43zxyG6i7yc_QCWPK-De9Xhxa0qirbfxYtTdegYUnuF8f282iw',
                  "Content-Type": "application/json",
                   'X-Trace-Id': traceId,
                   'X-KlickEx-Client':buildClientHeader(),
                }),
                body: JSON.stringify(state)
              }).then((response) => {
                if (response.status === 200) {
                  response.json().then((json) => {
                    this.setState(
                      {
                        tokenListData: json.result,
                      },
                      () => {
                        console.log("tokenListData", this.state.tokenListData)
                        this.setState({
                            loader : false
                        })
                      }
                    );
                    // toast.success(response.headers.get("message"), {
                    //   position: "top-right",
                    //   autoClose: 3000,
                    //   hideProgressBar: false,
                    //   closeOnClick: true,
                    //   pauseOnHover: true,
                    //   draggable: true,
                    //   draggablePercent: 60,
                    // });
                  });
                } else if (response.status === 401) {
                  toast.error(response.headers.get("message"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                  });
                  this.setState({
                            loader : false,
                  })
                } else {
                  toast.error(response.headers.get("message"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                  });
                  this.setState({
                        loader : false
                    })
                }
              });

        }
    }   

handleClose = () => {
    document.getElementById("myModal").style.display = "none"
    this.setState({
        reason : '',
    },()=>{
        this.setState({
         loader : false,
        })
    })
}
handleAction = (updateAction) =>{
    this.setState({
        updateAction
    },()=>{
        document.getElementById('myModal').style.display = 'block'
    })
}
onChange = (e , value) =>{
        this.setState({
            [e.target.name]: e.target.value
        })

        if(e.target.value.length > 0 ){
            this.setState({
                disabled : false
            })
        }else{
            this.setState({
                disabled : true
            })
        }
}
handleUpdate = () =>{
        console.log("Clicked Action")
        this.setState({
            loader : true
        })

          let state = {
            kitNo: this.state.selectedCard.kitNo,
            entityId:  this.state.selectedCard.customerId ,
            reason: this.state.reason,
            tokenUpdateType: this.state.updateAction,
            tokenReferenceId: this.state.tokenListData.tokenDetails[0].tokenReferenceID,
            tokenRequesterId: this.state.tokenListData.tokenDetails[0].tokenRequestorID,
            operationType: this.state.updateAction==='DELETE'? 'DELETE' : 'UPDATE',
          }
          //console.log("Sending Values" , state)
            let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
             let traceId = getClientId();
            fetch(plink + s.updateTokens, {
                method: "POST",
                headers: new Headers({
                  Authorization: `Token ${localStorage.getItem("token")}`,
                   'X-Trace-Id': traceId,
                //   Authorization : 'Token eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDaGFybGllUkwiLCJhY2NvdW50SWQiOiIyMTJGQ0hBUkxJRSIsInJvbGUiOiJhZG1pbiIsImlzcyI6IiNAIUhlYWx0aDVDa21mIUAjIiwiZXhwIjoxNzUxNTMxOTAzLCJpYXQiOjE3NTE0NDU1MDN9.IHRg20byY1Y9ISKNdsTXH8ToVkzEVpGq9nnBjHqQNCJV80xAGjjE6RZvAHIouxxYsKJ0hrAn0gU-NjECsIln-g',
                  "Content-Type": "application/json",
                  'X-KlickEx-Client':buildClientHeader(),

                }),
                body: JSON.stringify(state)
              }).then((response) => {
                if (response.status === 200) {
                  response.json().then((json) => {
                    toast.success(response.headers.get("message"), {
                      position: "top-right",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      draggablePercent: 60,
                    });

                    this.handleClose()
                    this.dogetToken()
                    this.setState({
                        loader : false,
                        reason :"",
                    })
                  });
                } else if (response.status === 401) {
                  toast.error(response.headers.get("message"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                  });
                  this.setState({
                    loader : false,
                  })
                } else {
                  toast.error(response.headers.get("message"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                  });
                    this.handleClose()
                    this.dogetToken()            
                  this.setState({
                    loader : false,
                    reason :"",
                  })
                }
              });
}
    render() {      
       
        const { cardState } = this.props
        const { selectedCard, cardAccount , tokenListData, filteredCards } = this.state
        console.log("State" , this.state)
        console.log("Props" , this.props)

        return (
            <div  className="row">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />            

                <div className="col-md-12 m-0 p-0">
                    <AuthNavbar />
                </div>
                <div className="container" style={{ }}>

                <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(52, 58, 64)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Update Token</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(52, 58, 64)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" , textAlign : "left"}}>
                                <span>Are you sure you want to update token?
                                </span>
                            </div>
                            <div className="col-sm-12 tokenreason" style={{ fontSize: "20px" }}>
                                <TextField
                                    //hintText="Start Typing"
                                    floatingLabelText="Reason"
                                    id="reason"
                                    type="text"
                                    maxLength="50"
                                    name="reason"
                                    autoComplete='none'
                                    autoFocus={true}
                                    value={this.state.reason}
                                    onChange={this.onChange}
                                    className="my-className input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-sm-3 offset-3" style={{ padding: "0px", textAlign: "right" }}>
                                        <button type="button" 
                                         className="btn-std"
                                        backgroundColor="#333"
                                        labelColor="#115876"
                                        data-dismiss="modal" 
                                        style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", padding: "8px 15px" }}
                                            onClick={this.handleUpdate.bind(this)}
                                            disabled = {this.state.disabled }
                                            aria-label="Close">
                                            OK
                                       </button>
                                    </div>
                                    <div className="col-sm-3" style={{ textAlign: "left" }}>
                                        <button type="button" 
                                          className="btn-std"
                                        backgroundColor="#333"
                                        labelColor="#115876"
                                        data-dismiss="modal" 
                                        style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", padding: "8px 15px" }}
                                            onClick={this.handleClose.bind(this)}
                                            aria-label="Close">
                                            Cancel
                                       </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                    <div className='col-md-12'>
                        {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 && filteredCards.length !== 0 ?
                            <div className="card-account fixedparent">
                                <div className="row">
                                    <div className="col-md-12" style={{ padding: "0px 15px" }}>
        
                                    <div className="fixedchild" >
                                        {filteredCards.length !== 0 &&
                                            <SelectField
                                                floatingLabelText=""
                                                onChange={this.handleSelect}
                                                className="input-width"
                                                name="Selected Card"
                                                autoComplete='none'
                                                style={{ marginTop: -12 }}
                                                value={cardAccount}>
                                                {filteredCards.map((value, i) =>
                                                    <MenuItem className="menuitem" value={filteredCards[i].cardDetailsId} primaryText={filteredCards[i].cardNumber} key={i} />
                                                )}
                                            </SelectField>}
                                    </div>
                                    </div>
                                    {/* <div className="col-sm-12 mt-5">
                                        <div className="row">
                                            <CardInfo
                                                selectedNewCard={this.state.selectedNewCard} />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
        
                            : <Loader />
                        }
                    </div>
                    <div className="row pb-5">
                        <div className="col-sm-12 p-3" >
                            <div className="row">
                                <div className="col-sm-12 mt-3" style={{ padding: "0px 30px" }}>
                                    <div className="row">
                                        <div className="header-style col-sm-12" style={{ padding: "5px 20px 0px 20px" }}>
                                            <h4 className='logmainheading mainheading'>Tokens List</h4>
                                            {/* <p className='subinfo'>Personal Information </p> */}
                                        </div>
                                        <div className="col-sm-12 mt-3" style={{ padding: "5px 20px 0px 20px" }}>
                                            <div>
                                                {this.state.loader ? <div ><Loader /></div> 
                                                :
                                                    <table className="table table-striped" style={{width : "100%"}}>

                                                    <thead className='table-dark'>
                                                        <tr style={{ fontSize: "13px" }}>
                                                            <th style={{ width: "25%", verticalAlign: "top", }} >Token Requestor Name </th>
                                                            <th style={{ width: "20%" }}>Action By</th>
                                                            <th style={{ width: "15%" }}>Device Type</th>
                                                            <th style={{ width: "20%", verticalAlign: "top", }}>Status</th>
                                                            <th style={{ width: "20%" }}>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(
                                                        tokenListData && tokenListData.tokenDetails && tokenListData.tokenDetails.length !== 0 && tokenListData.tokenDetails.map((value, i) =>
                                                            <tr style={{ fontSize: "13px", padding: "5px !important" }} key={i}>
                                                                <td >{value.tokenRequesterName}</td>
                                                                <td >{value.entityOfLastAction === 'TOKEN_REQUESTOR' ? 'REQUESTOR' : value.entityOfLastAction }</td>
                                                                <td >{value.deviceName} </td>
                                                                <td >{value.tokenStatus}</td>
                                                                <td >
                                                                    {(value.tokenStatus === 'ACTIVE' && value.tokenStatus !== 'DEACTIVATED' && value.tokenStatus !== 'SUSPENDED') ?
                                                                        <i className="fa fa-ban" aria-hidden="true" onClick={(e) => { this.handleAction('SUSPEND') }} style={{cursor : 'pointer'}} title="Suspend" ></i>    
                                                                        :
                                                                        <i className="fa fa-ban" aria-hidden="true" style={{ color : 'grey'  }} title="Suspend" ></i>    
                                                                    }
                                                                    {(value.tokenStatus !== 'ACTIVE' && value.tokenStatus !== 'DEACTIVATED') ?
                                                                        <i className="fa fa-repeat" aria-hidden="true" onClick={(e) => { this.handleAction('RESUME') }} style={{ cursor : 'pointer' , marginLeft: 15 }} title="Resume" ></i>
                                                                        :
                                                                        <i className="fa fa-repeat" aria-hidden="true" style={{ color : 'grey' , marginLeft: 15 }} title="Resume" ></i>
                                                                    }
                                                                    {value.tokenStatus !== 'DEACTIVATED' ?
                                                                    <i className="fa fa-trash" aria-hidden="true" onClick={(e) => { this.handleAction('DELETE') }} style={{ cursor : 'pointer' , marginLeft: 15 }} title="Delete" ></i>
                                                                    :
                                                                    <i className="fa fa-trash" aria-hidden="true" style={{ color : 'grey' , marginLeft: 15 }} title="Delete" ></i>
                                                                    }
                                                                </td>
                                                            </tr>))
                                                        }

                                                    </tbody>
                                                    </table>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
TokenList.defaultProps = {
    cardState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenList);




// WEBPACK FOOTER //
// ./src/components/wallet/tokenlist.jsx